import { render, staticRenderFns } from "./SubstanceAllergies.vue?vue&type=template&id=f643587e"
import script from "./SubstanceAllergies.vue?vue&type=script&lang=js"
export * from "./SubstanceAllergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports